<template>
    <div class="login d-lg-flex w-100">
        <div class="d-none d-lg-block login-image">
            <img src="@/assets/images/auth/login-bg.jpg" alt="1Byte" />
        </div>
        <div class="login-content min-w-320-px w-100 h-100">
            <div class="container h-100">
                <div
                    class="
                        login-content-wrapper
                        d-flex
                        flex-column
                        justify-content-center
                        align-items-center
                        h-100
                    "
                >
                    <div class="login-logo text-center">
                        <a :href="homeURL">
                            <img
                                :src="
                                    require(`@/assets/images/themes/${theme.folderName}/logo.svg`)
                                "
                                alt="1Byte"
                                class="w-175-px"
                            />
                        </a>
                    </div>
                    <div class="login-title font-weight-600 text-xl text-grey">
                        {{ $t('auth.login_title') }}
                    </div>
                    <VerifyTwoFALoginForm
                        v-if="
                            currentLoginMessage ===
                            LOGIN_MESSAGE.TWO_FACTOR_AUTH_ENABLED
                        "
                        :data-login="dataLogin"
                        @back="setCurrentLoginMessage('')"
                    ></VerifyTwoFALoginForm>
                    <FirstChangePasswordForm
                        v-else-if="
                            currentLoginMessage ===
                            LOGIN_MESSAGE.FORCE_PASSWORD_CHANGE
                        "
                        :data-login="dataLogin"
                        @back="setCurrentLoginMessage('')"
                        @onPasswordUpdated="onLogin"
                    ></FirstChangePasswordForm>
                    <LoginForm v-else @onLogin="onLogin"></LoginForm>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { LOGIN_MESSAGE } from '@/constants/auth';
import { CHECK_TOKEN_INTERVAL_TIME, THEMES } from '@/constants/config';
import { STORAGE_KEY } from '@/constants/storage';
import FirstChangePasswordForm from '@/views/Login/components/FirstChangePasswordForm/FirstChangePasswordForm';
import LoginForm from '@/views/Login/components/LoginForm/LoginForm';
import VerifyTwoFALoginForm from '@/views/Login/components/VerifyTwoFALoginForm/VerifyTwoFALoginForm';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'Login',
    components: { FirstChangePasswordForm, VerifyTwoFALoginForm, LoginForm },
    data() {
        return {
            intervalCheckCookie: null,
            LOGIN_MESSAGE,
            dataLogin: {},
            body: document.querySelector('body'),
            theme:
                THEMES[process.env.VUE_APP_THEME?.toUpperCase()] ||
                THEMES.DEFAULT,
        };
    },
    computed: {
        ...mapState('auth', ['currentLoginMessage']),
        homeURL() {
            return this.$helpers.homeURL();
        },
    },
    created() {
        this.toggleBodyStyle(true);
        this.checkCookieInterval();
        this.fetchCountry();
    },
    beforeDestroy() {
        this.setCurrentLoginMessage('');
        this.toggleBodyStyle(false);
        clearInterval(this.intervalCheckCookie);
    },
    methods: {
        ...mapActions('guest', ['fetchCountry']),
        checkCookieInterval() {
            clearInterval(this.intervalCheckCookie);
            this.intervalCheckCookie = setInterval(() => {
                const token = this.$cookies.get(STORAGE_KEY.ACCESS_TOKEN);
                if (this.$helpers.cookieParse(token)) {
                    this.$helpers.leaveLoginPage();
                }
            }, CHECK_TOKEN_INTERVAL_TIME);
        },
        setCurrentLoginMessage(value) {
            this.$store.commit('auth/setCurrentLoginMessage', value);
        },
        async onLogin(data) {
            switch (data.messageCode) {
                case LOGIN_MESSAGE.TWO_FACTOR_AUTH_ENABLED:
                    this.dataLogin = data;
                    this.setCurrentLoginMessage(
                        LOGIN_MESSAGE.TWO_FACTOR_AUTH_ENABLED
                    );
                    break;
                case LOGIN_MESSAGE.FORCE_PASSWORD_CHANGE:
                    this.dataLogin = data;
                    this.setCurrentLoginMessage(
                        LOGIN_MESSAGE.FORCE_PASSWORD_CHANGE
                    );
                    break;
                case LOGIN_MESSAGE.SUGGEST_ENABLE_2FA:
                    this.dataLogin = data;
                    this.setCurrentLoginMessage(
                        LOGIN_MESSAGE.SUGGEST_ENABLE_2FA
                    );
                    await this.$store.dispatch('auth/setToken', data);
                    break;
                case LOGIN_MESSAGE.SUCCESS:
                    this.setCurrentLoginMessage('');
                    await this.$store.dispatch('auth/setToken', data);
                    break;
            }
        },
        toggleBodyStyle(enable) {
            this.body.classList.toggle('bg-white', enable);
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'Login';
</style>
